import { Button, Card, Input, Select } from "antd";
import _ from "lodash";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useRef } from "react";

import { FilterIcon } from "../components/filterIcon";

const { Option } = Select;

/*
 * Search filter for tables
 * Compatible with both hooks and class
 */
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function searchFilter(searchKey: any, name: any, onFilter?: any) {
  // @ts-expect-error TODO(typecheck-unify): TS7034 Variable 'searchInput' implicitly has type 'any' in some locations where its type cannot be determined.
  let searchInput;

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'props' implicitly has an 'any' type.
  function SearchInput(props) {
    searchInput = useRef(null);

    return <Input ref={searchInput} {...props} />;
  }

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'value' implicitly has an 'any' type.
  const defaultFilter = (value, record) => {
    const searchValue = _.get(record, searchKey, "");

    return searchValue.toLowerCase().includes(value.toLowerCase());
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'visible' implicitly has an 'any' type.
  const onFilterDropdownVisibleChange = (visible) => {
    if (visible) {
      setTimeout(() => {
        // @ts-expect-error TODO(typecheck-unify): TS7005 Variable 'searchInput' implicitly has an 'any' type.
        searchInput.current.focus();
      });
    }
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'filtered' implicitly has an 'any' type.
  const filterIcon = (filtered) => <FilterIcon styled={{ filtered }} />;

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
    <Card
      actions={[
        <Button type="primary" onClick={confirm} key="search">
          {" "}
          Search
        </Button>,
        <Button onClick={clearFilters} key="reset">
          Reset
        </Button>,
      ]}
      size="small"
    >
      <SearchInput
        placeholder={`Search ${name}`}
        value={selectedKeys[0]}
        onChange={(e: any) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={confirm}
      />
    </Card>
  );

  return {
    onFilter: onFilter || defaultFilter,
    filterIcon,
    filterDropdown,
    onFilterDropdownVisibleChange,
  };
}

/*
 * Multiple select filter for tables
 * Compatible with both hooks and class
 */
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function multiSelectFilter(props: any) {
  const { name, dataSource = [], width } = props;
  // @ts-expect-error TODO(typecheck-unify): TS7034 Variable 'searchInput' implicitly has type 'any' in some locations where its type cannot be determined.
  let searchInput;

  // FIXME: Automatically disabled during ESLint config update
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'props' implicitly has an 'any' type.
  // eslint-disable-next-line @typescript-eslint/no-shadow
  function SelectInput(props) {
    searchInput = useRef(null);

    return <Select mode="multiple" ref={searchInput} optionFilterProp="children" {...props} />;
  }

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'visible' implicitly has an 'any' type.
  const onFilterDropdownVisibleChange = (visible) => {
    if (visible) {
      setTimeout(() => {
        // @ts-expect-error TODO(typecheck-unify): TS7005 Variable 'searchInput' implicitly has an 'any' type.
        searchInput.current.focus();
      });
    }
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'filtered' implicitly has an 'any' type.
  const filterIcon = (filtered) => <FilterIcon styled={{ filtered }} />;

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
    <Card
      actions={[
        <Button type="primary" onClick={confirm} key="search">
          Search
        </Button>,
        <Button onClick={clearFilters} key="reset">
          Reset
        </Button>,
      ]}
      size="small"
    >
      <SelectInput
        style={{ width: width || "200px" }}
        placeholder={`Search ${name}`}
        onChange={setSelectedKeys}
        value={selectedKeys}
      >
        {/* @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type. */}
        {dataSource.map((data) => (
          <Option key={data._id}>{data.name}</Option>
        ))}
      </SelectInput>
    </Card>
  );

  return {
    filterIcon,
    filterDropdown,
    onFilterDropdownVisibleChange,
  };
}
